import React, { useState, useEffect, useMemo } from "react";
import { Modal, Icon, Checkbox, Spin } from "antd";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { debounce } from "lodash";
import moment from "moment";
import BUDGET_API from "../../../../../apis/budget.api";
export const EditRecurringPattren = ({
  open,
  handleCancel,
  handleSave,
  handleDelete,
  handleSaveAddPattren,
  data,
  loading,
}) => {
  const [patterns, setPatterns] = useState(
    (data && data.recurring_patterns) || []
  );
  const [editedPatternId, setEditedPatternId] = useState(null);
  const [newPattern, setNewPattern] = useState(null);

  const [searchResults, setSearchResults] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);

  const handlePatternChange = (id, field, value) => {
    setPatterns((prev) =>
      prev.map((pattern) =>
        pattern.id === id ? { ...pattern, [field]: value } : pattern
      )
    );
  };

  const savePattern = async(id) => {
    const patternToSave = patterns.find((pattern) => pattern.id === id);
    let payload = {
      patternId: id,
      pattern: patternToSave && patternToSave.pattern,
      tokenId: data.id,
      selectedTransactions:selectedTransactions && selectedTransactions,
    };

    console.log("payload", payload);
    await handleSave(payload);
    setEditedPatternId(null); // Exit edit mode
    setSelectedTransactions([]);
    setCurrentPage(1);
    setTotalPages(1);
    setSearchResults([]);
  };
  const deletePattern = (id) => {
    let payload = {
      patternId: id,
      tokenId: data.id,
    };
    setPatterns((prev) => prev.filter((pattern) => pattern.id !== id));
    console.log("payload", payload);
    handleDelete(payload);
    setEditedPatternId(null); // Exit edit mode
  };
  const handleAddPattern = () => {
    const newId = Date.now(); // Generate a unique ID for new patterns
    setNewPattern({ id: newId, pattern: "" });
    setEditedPatternId(newId);
  };
  const saveNewPattern = async () => {
    if (newPattern && newPattern.pattern.trim() !== "") {
      const payload = {
        pattern: newPattern.pattern,
        tokenId: data.id,
      };
      console.log("payload", payload);
      const res = await handleSaveAddPattren(payload);
      console.log("res pattren", res.body.result);
     
      if (res && res.body && res.body.result && res.body.result) {
        setPatterns([...patterns, res.body.result]);
      }
      const selectedTransactionsIds= selectedTransactions && selectedTransactions.map((row) => row.id);
      const payloadData={
        tokenId : data.id,
        patternId :res && res.body && res.body.result && res.body.result && res.body.result.id,
        transactionIds:selectedTransactionsIds,
      }
      let dataRes = await BUDGET_API.createTransactionsForRecurring(payloadData);

      setNewPattern(null);
      setEditedPatternId(null);
      setSelectedTransactions([]);
      setCurrentPage(1);
      setTotalPages(1);
      setSearchResults([]);
    }
  };
  const toggleTransactionSelection = (transaction) => {
    console.log("transaction", transaction);
    setSelectedTransactions((prevSelected) => {
      const isSelected = prevSelected.some((t) => t.id === transaction.id);
      if (isSelected) {
        return prevSelected.filter((t) => t.id !== transaction.id);
      } else {
        return [...prevSelected, transaction];
      }
    });
  };
  const searchPatternTransactions = useMemo(
    () =>
      debounce(async (query, page = 1, limit = 10) => {
        if (!query) {
          setSearchResults([]);
          return;
        }
        setSearchLoading(true);
        try {
          let response = await BUDGET_API.searchRecurringAppliedTransaction(
            page,
            limit,
            query
          );
          if (response && response.data) {
            setSearchResults((prev) =>
              page === 1 ? response.data : [...prev, ...response.data]
            );
            setTotalPages(response.totalPages);
            setCurrentPage(page);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        }
        setSearchLoading(false);
      }, 500),
    []
  );
  // useEffect(() => {
  //   searchPatternTransactions(inputValue, 1);
  // }, [inputValue]);
  useEffect(() => {
    return () => {
      searchPatternTransactions.cancel();
    };
  }, []);
  const handleScroll = () => {
    const container = document.getElementById("transactions-search");
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (
      scrollTop + clientHeight >= scrollHeight - 10 &&
      !loadingMore &&
      currentPage < totalPages
    ) {
      setLoadingMore(true);
      const query =
      editedPatternId !== null
        ? patterns.find((p) => p.id === editedPatternId).pattern || ""
        : newPattern && newPattern.pattern || "";

      if(query){
        searchPatternTransactions(query, currentPage + 1);
      }
      setLoadingMore(false);
    }
  };
  return (
    <Modal
      visible={open}
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      centered
    >
      <h3 className="modaltitle">Recurring Pattren Update</h3>

      <div
        style={{ marginTop: "1rem", maxHeight: "25rem", overflow: "scroll" }}
      >
        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">
            Token <span style={{ color: "red" }}>*</span>
          </h3>
          <input
            className="roleInput"
            placeholder="Token Name"
            value={data && data.token}
            disabled={true}
            style={{ cursor: "not-allowed" }}
          />
        </div>
        <div className="patterns-display">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Icon
              type="plus"
              color="black"
              style={{ fontSize: "20px", fontWeight: "bold" }}
              onClick={() => {
                handleAddPattern();
              }}
            />
          </div>
          {newPattern && (
            <React.Fragment>
              <div className="patternItem" style={{ paddingInline: "1rem" }}>
                <input
                  className="roleInput"
                  value={newPattern.pattern}
                  onChange={(e) => {
                    setNewPattern({ ...newPattern, pattern: e.target.value });
                    searchPatternTransactions(e.target.value, 1);
                  }}
                />
                <Icon
                  type="save"
                  color="black"
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                  onClick={saveNewPattern}
                />
              </div>
              {searchLoading && <Spin />}
              {!searchResults ? (
                <Spin />
              ) : (
                <div
                  className="searchResults"
                  style={{ maxHeight: "10rem", overflowY: "auto" }}
                  id="transactions-search"
                  onScroll={handleScroll}
                >
                  {searchResults.length > 0 ? (
                    searchResults.map((transaction) => (
                      <div
                        key={transaction.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          borderBottom: "1px solid #ddd",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleTransactionSelection(transaction)}
                      >
                        <Checkbox
                          checked={selectedTransactions.some(
                            (t) => t.id === transaction.id
                          )}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => {
                            event.stopPropagation(); // Prevents the div's onClick from being triggered
                            toggleTransactionSelection(transaction);
                          }}
                          // onChange={() => toggleTransactionSelection(transaction)}
                        />
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.itemName}
                        </span>
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.date
                            ? moment(transaction.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </span>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: "#aaa", textAlign: "center" }}>
                      No transactions found
                    </p>
                  )}
                </div>
              )}
            </React.Fragment>
          )}
          {patterns.map((pattern) => (
            <div key={pattern.id} className="patternItem" style={{display:"flex",flexDirection:"column"}}>
            <div className="patternItem" style={{width:"100%"}}>
              {editedPatternId === pattern.id ? (
                <React.Fragment>
                  <input
                    className="roleInput"
                    value={pattern.pattern}
                    onChange={(e) => {
                      handlePatternChange(
                        pattern.id,
                        "pattern",
                        e.target.value
                      );
                      searchPatternTransactions(e.target.value, 1);
                    }}
                  />
                 
                </React.Fragment>
              ) : (
                <span>{pattern.pattern}</span>
              )}
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                // onClick={() =>
                //   editedPatternId === pattern.id
                //     ? savePattern(pattern.id)
                //     : setEditedPatternId(pattern.id)
                // }
              >
                {editedPatternId === pattern.id ? (
                  <Icon
                    type="save"
                    color="black"
                    onClick={() => {
                      if (editedPatternId === pattern.id) {
                        savePattern(pattern.id);
                      }
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <Icon
                      type="edit"
                      color="black"
                      onClick={() => {
                        setEditedPatternId(pattern.id);
                      }}
                    />
                    <Icon
                      type="delete"
                      color="black"
                      onClick={() => {
                        deletePattern(pattern.id);
                      }}
                    />
                  </div>
                )}
              </span>
              </div>
               {searchLoading && <Spin />}
                  {!searchResults ? (
                    <Spin />
                  ) : (
                    <div
                      className="searchResults"
                      style={{ maxHeight: "10rem", overflowY: "auto",width:"100%" }}
                      id="transactions-search"
                      onScroll={handleScroll}
                    >
                      {searchResults.length > 0 ? (
                        searchResults.map((transaction) => (
                          <div
                            key={transaction.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "8px",
                              borderBottom: "1px solid #ddd",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              toggleTransactionSelection(transaction)
                            }
                          >
                            <Checkbox
                              checked={selectedTransactions.some(
                                (t) => t.id === transaction.id
                              )}
                              onClick={(event) => event.stopPropagation()}
                              onChange={(event) => {
                                event.stopPropagation(); // Prevents the div's onClick from being triggered
                                toggleTransactionSelection(transaction);
                              }}
                              // onChange={() => toggleTransactionSelection(transaction)}
                            />
                            <span style={{ marginLeft: "1rem" }}>
                              {transaction.itemName}
                            </span>
                            <span style={{ marginLeft: "1rem" }}>
                              {transaction.date
                                ? moment(transaction.date).format("MM-DD-YYYY")
                                : "N/A"}
                            </span>
                          </div>
                        ))
                      ) : (
                        <p style={{ color: "#aaa", textAlign: "center" }}>
                          No transactions found
                        </p>
                      )}
                    </div>
                  )}
            </div>
          ))}
        </div>
      </div>

      <div className="buttonsMain" style={{ justifyContent: "center" }}>
        <button className="cancelbutton" onClick={handleCancel}>
          Cancel
        </button>
      </div>
      <NewLoader isLoading={loading} />
    </Modal>
  );
};
